import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import FAQ from "./components/pages/FAQ/FAQ";
import NotFound from "./components/pages/NotFound/NotFound";
import { OrderProvider } from "./context/OrderContext";
import NewCart from "./components/pages/Cart/NewCart";
import NewThankYou from "./components/pages/ThankYou/NewThankYou";
import Sponsors from "./components/pages/Sponsors/Sponsors";
import Upgrade from "./components/pages/Upgrade/Upgrade";
import UpgradeThanks from "./components/pages/Upgrade/UpgradeThanks";
import ProtegeHome from "./components/pages/Home/ProtegeHome";
import { ProtegeProtect } from "./components/protected/ProtegeProtect";
import { UpdateProtect } from "./components/protected/UpgradeProtect";
import Private from "./components/Private";
import NewHome from "./components/pages/Home/NewHome";
import Affiliate from "./components/pages/Affiliate/Affiliate";
import Competition from "./components/pages/Competition/Competition";
import CompetitionThankYou from "./components/pages/Competition/CompetitionThankYou";
import CompTnCs from "./components/pages/Competition/CompTnCs";
import useFacebookPixel from "./components/utils/useFacebookPixel";
import Floorplan from "./components/pages/Floorplan";
import EarlyBird from "./components/pages/EarlyBird/EarlyBird";
import EarlyThankYou from "./components/pages/EarlyBird/EarlyThankYou";
import Voting from "./components/voting/Voting";
import VoteThankYou from "./components/voting/VoteThankYou";

const PIXEL_ID = "1790472721766913";

function PixelPageViews() {
  const { pathname } = useLocation();
  const { trackPageView } = useFacebookPixel({
    pixelId: PIXEL_ID,
    user: {
      // Replace with your real data source:
      email: window.currentUser?.email,
      firstName: window.currentUser?.firstName,
      lastName: window.currentUser?.lastName,
    },
    consentGiven: window.userConsentedAnalytics ?? true,
  });

  useEffect(() => {
    trackPageView();
  }, [pathname, trackPageView]);
  return null;
}

function App() {
  return (
    <OrderProvider>
      <div className="App">
        <BrowserRouter>
          <PixelPageViews />
          <Nav />
          <Routes>
            <Route path="/" element={<NewHome />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="*" element={<NotFound />} />
            <Route path="privacy-policy" element={<Private />} />
            <Route path="/map" element={<Floorplan />} />
            {/* //!ROUTES BELOW SHOULD BE UNCOMMMENTED AS REQUIRED */}
            {/* <Route
              path="priority"
              element={
                <ProtegeProtect>
                  <ProtegeHome />
                </ProtegeProtect>
              }
            /> */}
            {/* <Route path="/partner/:affiliateId" element={<Affiliate />} /> */}
            {/* <Route
              path="/upgrade"
              element={
                <UpdateProtect>
                  <Upgrade />
                </UpdateProtect>
              }
            /> */}
            {/* <Route path="/competition" element={<Competition />} />
            <Route
              path="/competition-thanks"
              element={<CompetitionThankYou />}
            />
            <Route path="/competition-tncs" element={<CompTnCs />} /> */}
            <Route path="/early-bird" element={<EarlyBird />} />
            <Route path="/early-bird-thanks" element={<EarlyThankYou />} />
            {/* <Route path="upgrade-thanks" element={<UpgradeThanks />} /> */}
            {/* <Route path="sponsors" element={<Sponsors />} /> */}
            <Route path="cart" element={<NewCart />} />
            <Route path="thank-you" element={<NewThankYou />} />
            <Route path="voting" element={<Voting />} />
            <Route path="vote-thank-you" element={<VoteThankYou />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </OrderProvider>
  );
}

export default App;
